import _ from 'lodash'
import { MutationTree } from 'vuex';
import {
  EvaluationInquiryApplication,
  EvaluationInquiryApplicationsState,
} from '@/store/applications/evaluationInquiries/types';

const mutations: MutationTree<EvaluationInquiryApplicationsState> = {
  gotEvaluationInquiryApplication: (
    state,
    vacation: EvaluationInquiryApplication,
  ) => {
    state.applications = _.uniqBy([
      vacation,
      ...state.applications,
    ], 'applicationId')
  },
};

export default mutations
